import { Component, Input, OnInit } from '@angular/core';
import { StepperReadyEvent, StepperService } from '@mydocma/import-export';
import { FaultWritingReportConfig } from '../../faults-writing-report.config';
import { writingStepperConfig } from '../faults-writing-stepper.config';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'mydocma-mm-writing-stepper',
  templateUrl: './faults-writing-stepper.component.html',
  styleUrls: ['./faults-writing-stepper.component.scss']
})
export class FaultsWritingStepperComponent implements OnInit  {

  @Input()
  reportConfig: FaultWritingReportConfig;
  @Input()
  mobileMode = false;

  private stepperServiceSubject = new BehaviorSubject<StepperService>(null);
  stepperService$ = this.stepperServiceSubject.asObservable();

  stepperConfig = writingStepperConfig;

  private steperService: StepperService;

  constructor() { }

  ngOnInit() {
  }

  onReadyEvent(event: StepperReadyEvent) {
    this.steperService = event.stepperService;
    this.stepperServiceSubject.next(this.steperService);
  }
}
